import CustomAutoComplete, { CustomAutoCompleteProps } from '../../UI/CustomAutoComplete';
import { Location } from '../../../types/Location.interface';
import { useMemo } from 'react';
import { compareLocations } from '../../../utils';
import { AutocompleteValue } from '@mui/material/useAutocomplete/useAutocomplete';

export type LocationAutocompleteProps<Multiple extends boolean | undefined = false> = {
    locationOptions: Location[];
    selectedLocation: null | Location | Location[];
    onChange: (locations: null | Location | Location[]) => void;
    sortByName?: boolean;
    isMultiSelect?: Multiple;
    label?: string;
} & Omit<CustomAutoCompleteProps<Location, Multiple>, 'options' | 'label' | 'value' | 'onChange' | 'labelKeys'>;

function LocationAutocomplete<Multiple extends boolean | undefined = false>({
    selectedLocation,
    onChange,
    locationOptions,
    isMultiSelect,
    sortByName = true,
    label = 'Standorte',
}: LocationAutocompleteProps<Multiple>) {
    const handleChangeSelectedLocations = (locations: AutocompleteValue<Location, Multiple, false, false>) => {
        if (Array.isArray(locations)) {
            const allLocationsObject = locations.find((location) => location.id === -1);
            if (allLocationsObject && locations.length > 1) {
                if (locations.indexOf(allLocationsObject) === locations.length - 1) {
                    onChange([allLocationsObject]);
                    return;
                } else {
                    onChange(locations.filter((location) => location.id !== allLocationsObject.id));
                    return;
                }
            }
        }

        onChange(locations);
    };

    const sortedOptions = useMemo(() => {
        return sortByName ? [...locationOptions].sort(compareLocations) : locationOptions;
    }, [locationOptions, sortByName]);

    return (
        <CustomAutoComplete
            isMultiSelect={isMultiSelect}
            options={sortedOptions}
            labelKeys={['code', 'city']}
            value={selectedLocation}
            label={label}
            onChange={handleChangeSelectedLocations}
            isOptionEqualToValue={(option: Location, value: Location) => option.id === value.id}
        />
    );
}

export default LocationAutocomplete;
